import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import SamplesPage from './pages/SamplesPage';
import ServicesPage from './pages/ServicesPage';
import HowItWorksPage from './pages/HowItWorksPage';
import PricingPage from './pages/PricingPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import AdminFileViewer from './pages/AdminFileViewer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import DownloadCoverPage from './pages/DownloadCoverPage';
import MediaUploadPage from './pages/MediaUploadPage';
import OrderConfirmation from './pages/OrderConfirmation';
import PaymentSuccess from './pages/PaymentSuccess';
import OrderStatusPage from './pages/OrderStatusPage';
import ReviewSubmissionPage from './pages/ReviewSubmissionPage';
import OurStoryPage from './pages/OurStoryPage';
import BackToTop from './components/BackToTop';
import WhatsAppFloat from './components/WhatsAppFloat';
import ScrollToTop from './components/ScrollToTop';

// Admin imports
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminVideos from './pages/admin/AdminVideos';
import AdminEnquiries from './pages/admin/AdminEnquiries';
import AdminTestimonials from './pages/admin/AdminTestimonials';
import AdminSettings from './pages/admin/AdminSettings';

import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <>
              <Header />
              <main><HomePage /></main>
              <Footer />
            </>
          } />
          <Route path="/samples" element={
            <>
              <Header />
              <main><SamplesPage /></main>
              <Footer />
            </>
          } />
          <Route path="/services" element={
            <>
              <Header />
              <main><ServicesPage /></main>
              <Footer />
            </>
          } />
          <Route path="/how-it-works" element={
            <>
              <Header />
              <main><HowItWorksPage /></main>
              <Footer />
            </>
          } />
          <Route path="/pricing" element={
            <>
              <Header />
              <main><PricingPage /></main>
              <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <Header />
              <main><AboutPage /></main>
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Header />
              <main><ContactPage /></main>
              <Footer />
            </>
          } />
          <Route path="/payment-success" element={
            <>
              <Header />
              <main><PaymentSuccess /></main>
              <Footer />
            </>
          } />
          <Route path="/upload/:orderId" element={
            <>
              <Header />
              <main><MediaUploadPage /></main>
              <Footer />
            </>
          } />
          <Route path="/order/:orderId" element={
            <>
              <Header />
              <main><OrderStatusPage /></main>
              <Footer />
            </>
          } />
          <Route path="/admin/files" element={
            <>
              <Header />
              <main><AdminFileViewer /></main>
              <Footer />
            </>
          } />
          <Route path="/privacy-policy" element={
            <>
              <Header />
              <main><PrivacyPolicy /></main>
              <Footer />
            </>
          } />
          <Route path="/terms-conditions" element={
            <>
              <Header />
              <main><TermsConditions /></main>
              <Footer />
            </>
          } />
          <Route path="/download-cover" element={
            <>
              <Header />
              <main><DownloadCoverPage /></main>
              <Footer />
            </>
          } />
          <Route path="/order-confirmation" element={
            <main><OrderConfirmation /></main>
          } />
          <Route path="/review/:orderId" element={
            <main><ReviewSubmissionPage /></main>
          } />
          <Route path="/our-story" element={<OurStoryPage />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="videos" element={<AdminVideos />} />
            <Route path="enquiries" element={<AdminEnquiries />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
        <WhatsAppFloat />
        <BackToTop />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
